// Encoding, segment write and CDN hand-off between the host and the newest
// segment a viewer can load. With 2 s segments this is about a second.
const EDGE_LAG_SEC = 1;
const MIN_DELAY_SEC = 2;
const MAX_DELAY_SEC = 90;

/**
 * Seconds between the host doing something and this viewer seeing it, or
 * null while unknown. hls.js reports how far playback sits behind the live
 * edge; Safari's native player exposes the edge as the end of `seekable`.
 */
export function measureHostDelaySec(hls, video) {
  if (!video || video.paused) return null;

  let behindEdge = null;
  if (hls && Number.isFinite(hls.latency) && hls.latency > 0) {
    behindEdge = hls.latency;
  } else if (video.seekable?.length) {
    behindEdge = video.seekable.end(video.seekable.length - 1) - video.currentTime;
  }
  if (!Number.isFinite(behindEdge) || behindEdge < 0) return null;

  return Math.min(MAX_DELAY_SEC, Math.max(MIN_DELAY_SEC, behindEdge + EDGE_LAG_SEC));
}
